@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.modal-body {
  padding: 16px;
  height: 380px;
}

.modal-body-text {
  font-size: 14px;
  line-height: 18px;
}

.table {
  width: 100%;
}

.table-header-row {
  width: 100%;
}

.email-header {
  font-size: 13px;
  line-height: 18px;
  padding: 0 0 0.5em 0.5em;
  text-align: left;
}

.nickname-header {
  text-align: left;
  width: 15em;
  font-size: 13px;
  line-height: 18px;
  padding: 0 0 0.5em 0.5em;
  margin-right: 0.5em;
}

.add-icon {
  width: 12px;
  height: auto;
  margin: 0 0.5em;
}

.table-rows {
  height: 3em;
  padding-bottom: 0.5em;
  vertical-align: top;
}

.nickname-input {
  margin-right: 0.5em;
  width: 15em;
}

.email-input {
  margin-right: 0.5em;
}

.delete-button-container {
  margin: -0.7em -0.4em 0 0;
  align-items: center;
  display: flex;
  height: 3.5em;
}

.delete-icon {
  width: auto;
  height: 18px;
  color: @grid-header--active-group-by-button--text-color;
}

.add-vendor-button {
  margin-bottom: 16px;
}
